import * as Yup from 'yup';

export const JoinWaitlistSchema = Yup.object().shape({
 email: Yup.string()
  .min(1)
  .required('Error! Please enter email address')
  .email('Error! Please enter a valid email address'),
});

export type JoinWaitlistDataType = Yup.InferType<typeof JoinWaitlistSchema>;

type InitialValues = {
 trackingId: string;
};

export const joinWaitlistInitialValues: InitialValues = {
 trackingId: '',
};

export interface IJoinWaitlistResponse {
 packageId: string;
 paid: boolean;
 scheduledDeliveryDate: string;
 shippingStatus: string;
}

export interface IJoinWaitlistDataRequest {
 trackingId: string;
}
